import React from 'react';
import '../../assets/css/pfc.css';

const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=in.medibuddy&hl=en';
const IOS_APP_URL = 'https://apps.apple.com/us/app/medibuddy-dr-labs-meds-abha/id946666981?ls=1';

const FooterLink = ({ href, children }) => (
  <a className="pfc-footer-link" href={href} target="_blank" rel="noopener noreferrer">{children}</a>
);

const GooglePlayIcon = () => (
  <svg width="18" height="18" viewBox="0 0 512 512" fill="none" aria-hidden="true">
    <polygon fill="#5CDADD" points="29.53,0 29.53,251.509 29.53,512 299.004,251.509" />
    <polygon fill="#BDECC4" points="369.067,180.547 262.175,119.467 29.53,0 299.004,251.509" />
    <polygon fill="#DC68A1" points="29.53,512 29.53,512 262.175,383.551 369.067,322.47 299.004,251.509" />
    <path fill="#FFCA96" d="M369.067,180.547l-70.063,70.961l70.063,70.961l108.688-62.877c6.288-3.593,6.288-11.677,0-15.27L369.067,180.547z" />
  </svg>
);

const AppleIcon = () => (
  <svg width="17" height="18" viewBox="0 0 291.538 291.538" fill="none" aria-hidden="true">
    <path fill="#fff" d="M188.373 44.308c10.97-11.744 18.39-28.049 16.359-44.308-15.804.564-34.958 9.277-46.302 21.02-10.169 10.396-19.072 27.011-16.696 42.951 17.635 1.193 35.651-7.938 46.639-19.663zM222.03 156.593c-.337-36.451 28.859-53.958 30.152-54.804-16.414-24.753-41.977-28.14-51.081-28.522-21.767-2.285-42.442 13.182-53.493 13.182-11.006 0-28.03-12.882-46.083-12.536-23.733.391-45.601 14.211-57.79 36.114C19.081 154.09 37.416 219.363 61.44 255.104c11.744 17.497 25.727 37.125 44.089 36.415 17.725-.71 24.407-11.789 45.792-11.789 21.394 0 27.384 11.789 46.101 11.434 19.045-.355 31.098-17.834 42.742-35.386 13.473-20.292 19.027-39.938 19.345-40.93-16.414-6.237-53.093-20.666-53.479-64.255z" />
  </svg>
);

const PFCFooter = () => (
  <footer className="pfc-footer">
    <div className="pfc-footer-wave">
      <svg viewBox="0 0 1280 50" preserveAspectRatio="none" aria-hidden="true">
        <path d="M0 0 L1280 0 L1280 15 Q960 50 640 32 Q320 15 0 40 Z" fill="#F5F7F8" />
      </svg>
    </div>
    <div className="pfc-footer-content">
      <div>
        <div className="pfc-footer-col-title">Hospitalization</div>
        <div className="pfc-footer-links" style={{ marginBottom: 20 }}>
          <FooterLink href="https://faq.medibuddy.in/?utm_source=medibuddywebfaq&type=general">FAQs</FooterLink>
        </div>
        <div className="pfc-footer-col-title">Our Policies</div>
        <div className="pfc-footer-links">
          <FooterLink href="https://www.medibuddy.in/terms">Terms of Use</FooterLink>
          <FooterLink href="https://www.medibuddy.in/privacy-policy">Privacy Policy</FooterLink>
          <FooterLink href="https://www.medibuddy.in/grievance-policy">Grievance Redressal</FooterLink>
          <FooterLink href="https://www.medibuddy.in/cancellation-refund-policy">Cancellation &amp; Refund Policy</FooterLink>
          <FooterLink href="https://www.medibuddy.in/security/bugbounty">Security at MediBuddy</FooterLink>
        </div>
      </div>
      <div>
        <div className="pfc-footer-col-title">ABOUT</div>
        <div className="pfc-footer-links">
          <FooterLink href="https://www.medibuddy.in/aboutus">About Us</FooterLink>
          <FooterLink href="https://www.medibuddy.in/health-services/medibuddy-for-corporates?web=true">Tailored Corporate Plans</FooterLink>
          <FooterLink href="https://www.medibuddy.in/contactus/">Contact Us</FooterLink>
          <FooterLink href="https://blog.medibuddy.in/">Blogs</FooterLink>
          <FooterLink href="https://www.medibuddy.in/security/bugbounty">Security</FooterLink>
        </div>
      </div>
      <div>
        <div className="pfc-footer-section-label">DOWNLOAD APP</div>
        <div className="pfc-footer-app-row">
          <a className="pfc-app-icon" href={ANDROID_APP_URL} target="_blank" rel="noopener noreferrer" aria-label="Open MediBuddy on Google Play">
            <GooglePlayIcon />
          </a>
          <a className="pfc-app-icon" href={IOS_APP_URL} target="_blank" rel="noopener noreferrer" aria-label="Open MediBuddy on the App Store">
            <AppleIcon />
          </a>
        </div>
        <div className="pfc-footer-section-label">FOLLOW US</div>
        <div className="pfc-footer-social">
          <a className="pfc-social-icon" href="https://www.facebook.com/MediBuddy/" target="_blank" rel="noopener noreferrer" aria-label="MediBuddy on Facebook">
            <svg width="9" height="16" viewBox="0 0 9 16" fill="none" aria-hidden="true"><path d="M6 5.5H8V3H6C4.3 3 3 4.2 3 6V7.5H1V10H3V16H5.5V10H8L8.5 7.5H5.5V6C5.5 5.7 5.7 5.5 6 5.5Z" fill="white" /></svg>
          </a>
          <a className="pfc-social-icon" href="https://www.linkedin.com/company/medibuddy/" target="_blank" rel="noopener noreferrer" aria-label="MediBuddy on LinkedIn">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true"><rect x="1" y="5" width="2.5" height="8.5" fill="white" /><circle cx="2.2" cy="2.2" r="1.4" fill="white" /><path d="M5.5 5H8V6.5C8.5 5.4 9.5 5 11 5C12.8 5 14 6 14 8.2V13.5H11.5V8.8C11.5 7.8 11 7.3 10 7.3C9 7.3 8.5 8 8.5 8.8V13.5H5.5V5Z" fill="white" /></svg>
          </a>
          <a className="pfc-social-icon" href="https://twitter.com/medibuddyapp" target="_blank" rel="noopener noreferrer" aria-label="MediBuddy on X">
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" aria-hidden="true"><path d="M14 1.5C13.4 1.8 12.8 2 12.1 2.1C12.8 1.7 13.3 1 13.5.2C12.8.6 12.1.9 11.3 1.1C10.7.4 9.8 0 8.8 0C6.9 0 5.4 1.5 5.4 3.4C5.4 3.7 5.4 3.9 5.5 4.2C2.9 4 1 2.7 0 .7C-.3 1.2-.5 1.7-.5 2.3C-.5 3.5.1 4.5 1 5.1C.5 5.1 0 4.9-.5 4.7V4.7C-.5 6.4.7 7.8 2.2 8.1C1.9 8.2 1.6 8.2 1.3 8.2C1.1 8.2.9 8.2.7 8.1C1.1 9.6 2.5 10.6 4.1 10.6C2.9 11.6 1.4 12.1-.2 12.1C-.5 12.1-.7 12.1-1 12.1C.6 13.1 2.5 13.7 4.5 13.7C9.8 13.7 12.7 8.7 12.7 4.4V4.4C12.7 4.3 12.7 4.1 12.7 4C13.3 3.5 13.8 2.8 14.3 2C13.8 2.3 13.3 2.5 12.8 2.6C13.4 2.2 14 1.6 14.3.9L14 1.5Z" fill="white" /></svg>
          </a>
        </div>
      </div>
    </div>
  </footer>
);

export default PFCFooter;
